import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

import { Link } from '@mui/material';

/**
 * Inline text link to an internal route: MUI `Link` styling over a React
 * Router `Link`. Use instead of hand-rolling `<Link component={RouterLink}>`;
 * all other MUI `Link` props (`color`, `underline`, `sx`, `style`, ...) pass
 * through, and it can be extended with `styled()`.
 */
const LinkText = ({ children, to, ...rest }) => (
  <Link component={RouterLink} to={to} {...rest}>
    {children}
  </Link>
);

LinkText.propTypes = {
  children: PropTypes.node.isRequired,
  /** Internal route path. */
  to: PropTypes.string.isRequired,
};

export default LinkText;
